"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tooltip = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const amountUtils_1 = require("../../util/amountUtils");
const common_styled_components_1 = require("../common-styled-components");
const theme_1 = require("../../theme");
const timeUtils_1 = require("../../util/timeUtils");
const TooltipContainer = styled_components_1.default.div `
  position: absolute;
  pointer-events: none;
  background-color: white;
  border: 1px ${(p) => (p.isPrediction ? "dashed" : "solid")}
    ${theme_1.theme.colors.grey(3)};
  padding: 4px ${theme_1.theme.spacing(2)};
`;
const TooltipValue = (0, styled_components_1.default)(common_styled_components_1.DetailP) `
  ${theme_1.theme.fontBold};
  ${theme_1.theme.fontSize(-1)};
`;
const getPositionStyle = (point, bbox, side, verticalSide) => {
    const style = {};
    if (side === "left") {
        style.right = bbox.width - point.x;
    }
    else {
        style.left = point.x;
    }
    if (verticalSide === "bottom") {
        style.top = point.y;
    }
    else {
        style.bottom = bbox.height - point.y;
    }
    return style;
};
const Tooltip = ({ tooltipData: { point, containerSize, data, isPrediction }, }) => {
    const side = point.x >= containerSize.width / 2 ? "left" : "right";
    const verticalSide = containerSize.height > data.length * 25 + point.y ? "bottom" : "top";
    return ((0, jsx_runtime_1.jsx)(TooltipContainer, { style: getPositionStyle(point, containerSize, side, verticalSide), isPrediction: isPrediction, children: data.map((series) => ((0, jsx_runtime_1.jsx)(TooltipValue, { style: { color: series.color }, children: series.dateValue !== undefined
                ? `${(0, timeUtils_1.formatDate)(series.dateValue.date)}: ${series.dateValue.value !== undefined
                    ? (0, amountUtils_1.formatNumber)(series.dateValue.value, 1)
                    : "N/A"}`
                : series.label !== undefined
                    ? `${series.label}: ${series.value !== undefined
                        ? (0, amountUtils_1.formatNumber)(series.value, 1)
                        : "N/A"}`
                    : "" }, series.series))) }));
};
exports.Tooltip = Tooltip;
